








import React, { useState } from "react";
import "../../styles/Careers.css";
import careersImage from "../../images/careers-slider.jpg";
import careersIcon from "../../assets/service-icon.png"; // Import the icon for headers
import { Link } from "react-router-dom";

const Careers = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    location: "",
    specialization: "",
    description: "",
    resume: null,
    captcha: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("contactNumber", formData.contactNumber);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("location", formData.location);
    formDataToSend.append("specialization", formData.specialization);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("resume", formData.rese);

    try {
      const response = await fetch("https://site2.akms.org.in/backend/submit-career/", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();
      console.log("Response:", data);
      alert(data.message);
    } catch (error) {
      console.error("Error submitting career form:", error);
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      contactNumber: "",
      email: "",
      location: "",
      specialization: "",
      description: "",
      resume: null,
      captcha: ""
    });
  };

  return (
    <div className="careers-container">
      {/* Image Slider */}
      <div className="careers-image-slider">
        <img src={careersImage} alt="Careers Slider" />
      </div>

      {/* Careers Form Section */}
      <div className="careers-form-card">
        {/* Title with Icon - Light blue style with vertical line */}
        <div className="careers-vertical-header">
          <img src={careersIcon} alt="Join Our Team" className="careers-header-icon rotate-on-hover" />
          <div className="careers-vertical-line"></div>
          <h3 className="careers-header-title">Join Our Team</h3>
        </div>
        
        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
          <input type="text" name="contactNumber" placeholder="Contact Number" value={formData.contactNumber} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="text" name="location" placeholder="Current Location" value={formData.location} onChange={handleChange} required />
          <input type="text" name="specialization" placeholder="Specialization" value={formData.specialization} onChange={handleChange} required />
          <textarea name="description" placeholder="Describe Yourself" value={formData.description} onChange={handleChange} required></textarea>
          <input type="file" name="resume" onChange={handleFileChange} required />
          {/* <input type="text" name="captcha" placeholder="Enter Captcha" value={formData.captcha} onChange={handleChange} required /> */}
          <div className="form-buttons">
            <button type="submit">Send</button>
            <button type="button" onClick={handleReset}>Reset</button>
          </div>
        </form>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <Link to="/privacy-statement" className="footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="footer-link"> Terms Of Use</Link>
            </p>
          </div>
          <div className="footer-center">
            <p>&copy; {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Careers;